module.exports = "/lucky-balls/img/infobox/info_Box_024.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/infobox/info_Box_024.png
// module id = 1089
// module chunks = 0